import { DEFAULT_FILE_TYPES } from "@certn/utils";
import { useField } from "formik";

import { FileUpload, FileUploadProps } from "../components/upload/FileUpload";
import { FileInfo } from "../components/upload/assets/utils";

export interface FileUploadFormikFieldProps extends FileUploadProps {
  name: string;
  label?: string;
  isRequired?: boolean;
  testID: string;
  orientation?: "horizontal" | "vertical";
  onFilesChange?: (files: FileInfo[]) => void;
}

export function FileUploadFormikField(props: FileUploadFormikFieldProps) {
  const { name, allowedFileTypes = DEFAULT_FILE_TYPES, onFilesChange } = props;
  const [field, meta, helpers] = useField(name);

  return (
    <FileUpload
      {...props}
      label={props.label}
      isRequired={props.isRequired}
      testID={props.testID}
      requestUrl={props.requestUrl}
      onBlur={() => {
        helpers.setTouched(true);
      }}
      allowedFileTypes={allowedFileTypes}
      isInvalid={Boolean(meta.touched && meta.error)}
      errors={meta.touched ? meta.error : undefined}
      files={field.value || []}
      setFiles={(files) => {
        helpers.setValue(files);
        helpers.setTouched(true);
        onFilesChange?.(files);
      }}
    />
  );
}
